export const filterNonNull = <T>(list?: (T | null | undefined)[]): Array<T> => {
  if (!list || !Array.isArray(list)) {
    return [];
  }

  return list.filter((element) => !!element) as Array<T>;
};
